import React from "react";
import { getPublishedShiftHours, isManagerCancelledShift } from "./attendanceCoverage";

const finiteNumber = (value) =>
  value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));

// Use schedule rows and punch-backed cards, independently of labor-model output.
export function getScheduleHourSummary(schedule = [], actualCards = [], roleTypes) {
  const scheduled = schedule.reduce((total, shift) => {
    if (!shift || shift.other_store || isManagerCancelledShift(shift) ||
      (roleTypes && !roleTypes.includes(shift.role_type))) return total;
    return total + (finiteNumber(shift.hours)
      ? Math.max(0, Number(shift.hours))
      : getPublishedShiftHours(shift));
  }, 0);
  const punches = actualCards.filter((card) =>
    !card.is_missed && finiteNumber(card.shift_start) &&
    finiteNumber(card.shift_end) && finiteNumber(card.hours)
  );
  return {
    scheduled,
    actual: punches.length ? punches.reduce((total, card) => total + Number(card.hours), 0) : null,
    inProgress: punches.some((card) => card.in_progress),
  };
}

export default function DailyNoLaborModelMetricsCard({
  actual_schedule = [], actualCards = [], checkedMetricsToggle,
  weekly_or_daily, day_of_week_str, roleTypes, publishedScheduledHours = 0, actualHoursAvailable = true, compact = false,
}) {
  const { scheduled: planned, actual, inProgress } = getScheduleHourSummary(actual_schedule, actualCards, roleTypes);
  const actualMode = checkedMetricsToggle && actualHoursAvailable;
  const scheduled = actualMode ? publishedScheduledHours : planned;
  return (
    <div className="w-full text-xs tabular-nums" aria-label={`${day_of_week_str || "Week"} schedule hours`}>
      {!compact && day_of_week_str && <p className="text-slate-500 font-medium mb-1">{day_of_week_str}</p>}
      <div className="flex items-center justify-between gap-2">
        <span className="text-slate-500">{compact && day_of_week_str ? day_of_week_str : "Scheduled"}{actualMode && weekly_or_daily === "weekly" ? " to date" : ""}</span>
        <span className="font-semibold text-slate-900 whitespace-nowrap">{scheduled.toFixed(2)} h</span>
      </div>
      {actualMode && (
        <div className="flex items-center justify-between gap-2 mt-1" title="Hours from available time records. Missing records are not counted as zero.">
          <span className="text-slate-500">Actual{weekly_or_daily === "weekly" || inProgress ? " to date" : ""}</span>
          <span className="font-semibold text-slate-900 whitespace-nowrap">{actual === null ? "No data yet" : `${actual.toFixed(2)} h`}</span>
        </div>
      )}
    </div>
  );
}
